module.exports = __webpack_public_path__ + "static/media/paddle-tennis.108d0ac4.jpg";